export const commonEnuns = {
  'ADMIN': 'Administrador',
  'FINISHED': 'Finalizado',
  'ONCE': 'Finalizado',
  'SCHEDULED': 'Agendado',
  'PROGRESS': 'Em Progresso',
  'ERROR': 'Com erro',
  'CANCELED': 'Cancelado'
};

export const severityEnumMap = {
  'CRITICAL': 'dashboard.criticize',
  'HIGH': 'dashboard.Alt',
  'MEDIUM': 'dashboard.average',
  'LOW': 'dashboard.Baixe',
  'DEFAULT': ''
}

export const enumStatusMap = {
  null: 'scan.story.scheduled',
  1: 'scan.story.not_executed',
  2: 'scan.story.in_execution',
  3: 'scan.story.finished',
  4: 'scan.story.error',
  5: 'scan.story.cancelled',
  6: 'scan.story.idle',
  7: 'scan.story.offline',
  8: 'scan.story.in_queue',
  9: 'scan.story.waiting_window',
  'scan.notFound': 'scan.notFound'
};

export const enumFilterStatusMap = {
  null: 'scan.story.scheduled',
  1: 'scan.story.not_executed',
  2: 'scan.story.in_execution',
  3: 'scan.story.finished',
  4: 'scan.story.error',
  5: 'scan.story.cancelled',
  9: 'scan.story.waiting_window',
};

export const enumFilterStatusScanFileMap = {
  1: 'scan.story.not_executed',
  2: 'scan.story.in_execution',
  3: 'scan.story.finished',
  4: 'scan.story.error',
  5: 'scan.story.cancelled',
};

export const periodicityEnum = {
  0: 'scan.never',
  1: 'scan.hour',
  2: 'scan.daily',
  3: 'scan.week',
  4: 'scan.month',
  5: 'scan.quarter',
};

export const batchPeriodicityEnum = {
  0: 'scan.never',
  2: 'scan.daily',
  3: 'scan.week',
  4: 'scan.month',
};

export const severityEnum = {
  0: 'dashboard.criticize',
  1: 'dashboard.Alt',
  2: 'dashboard.average',
  3: 'dashboard.Baixe'
};

export const enumModeltypes = {
  'REGEX': 'Expressão regular',
  'NAME': 'Nome de pessoas',
  'RELIGIOUS': 'Dados de religião',
  'MAPEAR': 'Mapear e Classificar',
  'KEY_WORD_COLUMN': 'Coluna - Palavras-Chave',
  'DICIONARIO': 'Dicionário de dados',
  'MULTIPLE_RULES': 'Múltiplas regras'
};

export const enumAdditionalValidationTypes = {
  CREDIT_CARD: "Cartão de crédito",
  CNPJ: "CNPJ",
  CPF: "CPF",
  VOTE_ID_CARD: "Título de eleitor",
  PIS: "PIS",
  CNH: "CNH",
  DATA: "Data",
  CEP: "CEP"
};

export const enumImportCredentials = {
  'Pending Validation': 'pendent.validation.label',
  'ERROR': 'error.label',
  'Active': 'detectors.active',
  'null': 'manual.creation.label'
};

export const enumRedactionStatus = {
  'F': 'redaction.table.status.finished',
  'P': 'redaction.table.status.pending',
  'W': 'redaction.table.status.pending',
  'A': 'redaction.table.status.analyzing',
  'M': 'redaction.table.status.unknown',
  'E': 'redaction.table.status.error',
  'X': 'redaction.table.status.canceled',
}

export const enumRedactionAnalysisStatus = {
  "FINISHED": 'redaction.table.status.finished',
  "PENDING_ANALYSIS": 'redaction.table.status.pending',
  "WAITING_CONSUMER": 'redaction.table.status.pending',
  "ANALYSIS": 'redaction.table.status.analyzing',
  "PENDING_MODELS": 'redaction.table.status.unknown',
  "ERROR_PROCESSING": 'redaction.table.status.error',
  "EXCLUIR": 'redaction.table.status.canceled',
  "FINISHED_WITH_ERROR": 'redaction.table.status.finished-with-error',
}

export const enumRedactionViewStatus = {
  0: 'redaction.label.private',
  1: 'redaction.label.public',
}

export const enumRedactionAnalysisViewStatus = {
  "PRIVATE": 'redaction.label.private',
  "PUBLIC": 'redaction.label.public',
}

export const enumStructure = {
  'M': 'metadata',
  'D': 'dados',
  'F': 'metadata.dados',
};

export const enumMonthMap = {
  0: 'Janeiro',
  1: 'Fevereiro',
  2: 'Março',
  3: 'Abril',
  4: 'Maio',
  5: 'Junho',
  6: 'Julho',
  7: 'Agosto',
  8: 'Setembro',
  9: 'Outubro',
  10: 'Novembro',
  11: 'Dezembro'
};

export const engineMap = [
  "Progress",
  "Apache Hadoop",
  "MySQL",
  "IBM DB2",
  "Postgres",
  "Oracle",
  "MS SQLSERVER",
  "Firebird",
  "MS SQLSERVER Linked",
  "MariaDb",
  "Snowflake",
  "Neo4j",
  "Tibero",
  "Open Search",
  "Trino",
  "BigQuery",
  "Azure Databricks"
]

export const enumStatusSearchFilter = {
  'Pendente': 'scan.story.in_queue',
  'Processando': 'scan.story.in_execution',
  'Concluído': 'scan.story.finished',
  'Erro': 'scan.search.error',
  'Cancelado': 'scan.story.cancelled'
}

export const getEnumValue = (key) => {
  return commonEnuns[key] || '';
};

// Dinamic URL Backend
export const getRuntimeBaseUrl = function () {

  const locationRuntime = window.location.href;

  const locationLink = document.createElement('a');
  locationLink.href = locationRuntime;

  const protocolUrl = locationRuntime.startsWith('https') ? 'https://' : 'http://';

  if (locationLink.hostname.includes('localhost'))
    return `${protocolUrl}${locationLink.hostname}:${process.env.REACT_APP_API_PORT || '8080'}/api`

  const port = process.env.REACT_APP_FORCE_API_PORT ? `:${process.env.REACT_APP_API_PORT || '8080'}` : ''
  return `${protocolUrl}${locationLink.hostname}${port}/api`;
};

// Generator uuidv4
export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //eslint-disable-next-line
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const getCurrentDateFormat = () => {
  const now = new Date();

  return `${enumMonthMap[now.getMonth()]} / ${now.getFullYear()}`;
};

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

export const REDACTION_FILES_DEFAULT_FILTERS = {
  status: [],
  createdAtFrom: null,
  createdAtTo: null,
  updatedAtFrom: null,
  updatedAtTo: null,
  visibility: null,

}

export const AUTOMATIC_ANALYSIS_DEFAULT_FILTERS = {
  status: [],
  collectFolder: null,
  destinationFolder: null,
  createdAtFrom: null,
  createdAtTo: null,
  startDateFrom: null,
  startDateTo: null,
  updatedAtFrom: null,
  updatedAtTo: null,
}

export const REDACTION_DETAILS_DEFAULT_FILTERS = {
  status: [],
  createdAtFrom: null,
  createdAtTo: null,
  updatedAtFrom: null,
  updatedAtTo: null,
}

export const SCAN_DEFAULT_FILTERS = {
  status: [],
  engines: [],
  createdAtFrom: null,
  createdAtTo: null,
  startDateFrom: null,
  startDateTo: null,
  endDateFrom: null,
  endDateTo: null,
}


export const SCAN_BATCH_DEFAULT_FILTERS = {
  repeat: [],
  status: [],
  scans: [],
  startDateFrom: null,
  startDateTo: null,
  startTimeFrom: null,
  startTimeTo: null,
  endDateFrom: null,
  endDateTo: null,
}

export const ENGINE_DEFAULT_FILTERS = {
  engines: [],
  integrationType: [],
  status: null,
}

export const DEFAULT_PREFERENCES_FORM = {
  activeExclusion: false,
  daysToExclusion: null,
}

export const HOLDER_DEFAULT_FILTERS = {
  key: "",
  createdAtFrom: null,
  createdAtTo: null,
  status: [],
}

export const HOLDER_DETAILS_DEFAULT_FILTERS = {
  scans: [],
  models: [],
  columns: [],
  origins: [],
  locations: [],
  categories: [],
}

export const HOLDER_DETAILS_GROUPED_DEFAULT_FILTERS = {
  models: [],
  origins: [],
  categories: [],
}

export const SCAN_DETAILS_DEFAULT_FILTERS = {
  categoryId: [],
  location: "",
  column: "",
}

export const FILE_VALIDATOR_DEFAULT_FILTERS = {
  status: [],
  createdAtFrom: null,
  createdAtTo: null,
  startDateFrom: null,
  startDateTo: null,
  endDateFrom: null,
  endDateTo: null,
}


export const SCAN_COMPARE_DEFAULT_FILTERS = {
  status: [],
  models: [],
  column: [],
  table: [],
}

const NEW_SCAN_DEFAULT_DATES = {
  id: null,
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null,
  repeat: 0,
  endDateType: 'NEVER',
  executionStatus: null,
  repeatWeekly: null,
  dayWeekly: null,
  repeatDayWeekly: [],
  dayOf: null,
  dayUntil: null,
}

export const NEW_SCAN_DEFAULT_VALUES = {
  id: null,
  activeSampling: true,
  appointmentDate: null,
  blockStartFormated: null,
  blockEndFormated: null,
  cleanResults: false,
  credentialId: null,
  description: "",
  dpUser: null,
  datas: NEW_SCAN_DEFAULT_DATES,
  engine: null,
  endDate: null,
  endTime: null,
  endDateType: null,
  hashResults: false,
  models: [],
  precision: 100,
  runImmediately: true,
  startDate: null,
  startTime: null,
  searchConfigs: [],
  sampling100: 5,
  sampling1m: 5,
  sampling10m: 5,
  sampling10mplus: 5,
  modelStructured: null
}

export const MODELS_CLASSIFICATION_DEFAULT_FILTERS = {
  tableList: [],
  schemaList: [],
}

export const SCAN_SEARCH_DEFAULT_FILTERS = {
  status: [],
  createdAtFrom: null,
  createdAtTo: null,
  expirationAtFrom: null,
  expirationAtTo: null,
  endDateFrom: null,
  endDateTo: null,
}


export const SCAN_SEARCH_DEFAULT_VALUES = {
  search: "",
  dataType: null,
}

export const SCAN_RESTRICTION_DEFAULT_FILTERS = {
  daysWeek: null,
  typesProcess: null,
  status: null,
  order: null,
  direction: null,
}

export const SCAN_RESTRICTION_DEFAULT_VALUES = {
  id: null,
  startTime: null,
  endTime: null,
  daysOfWeek: [],
  typesProcess: [],
  enable: false,
}

const NEW_BATCH_SCHEDULING_DEFAULT_DATES = {
  id: null,
  endTime: null,
  endDate: null,
  startDate: null,
  startTime: null,
  dayWeekly: null,
  repeatWeekly: null,
  executionStatus: null,
  repeat: 0,
  repeatDayWeekly: [],
  repeatInterval: null,
  occurrences: null,
  monthlyType: null,
  endDateType: 'NEVER',
}

export const NEW_BATCH_SCHEDULING_DEFAULT_VALUES = {
  id: null,
  dpUser: null,
  description: "",
  hashResults: false,
  cleanResults: false,
  scanIds: [],
  restrictions: [],
  datas: NEW_BATCH_SCHEDULING_DEFAULT_DATES,
}

export const USER_DEFAULT_VALUES = {
  encryptedId: '',
  username: '',
  email: '',
  profileId: null,
  emailScanUpdates: false,
  password: '',
}

export const EXCLUSION_DEFAULT_FILTERS = {
  createdAtFrom: null,
  createdAtTo: null,
}

export const DIALOG_INITIAL_STATE = {
  title: '',
  description: '',
  btnCancel: '',
  btnText: '',
};